export default "__VITE_ASSET__CBmTa1Jf__"